import React from 'react'
import $ from 'jquery'

import SearchResult from './SearchResult'
import TypeFilter from './TypeFilter'
// import BranchFilter from './BranchFilter'
import SearchApi from '../search-api'
import { find } from '../../../common/elements'
import __ from '../../../../react/utils/i18n'
import Map from '../../../components/map'

// this is crazy, webpack aliases?
import SearchIcon from '../../../../../icons/search.svg'
import LocationIcon from '../../../../../icons/location.svg'

class Search extends React.Component {
  constructor(props) {
    super(props)
    this.header = React.createRef()
    this.state = {
      cols: 1,
      branches: [],
      activeBranches: [],
      types: [],
      activeTypes: [],
      term: '',
      location: '',
      results: [],
      shownResults: [],
      total: null,
      searching: false,
      showMap: false,
      canSearch: false,
    }
    this.searchApi = SearchApi()
    this.mapEl = null
    this.map = null
    this.xhr = null

    this.hashChange = this.hashChange.bind( this );
  }

  async componentDidMount() {

    window.addEventListener( 'hashchange', this.hashChange );

    // const storedState = JSON.parse(sessionStorage.getItem('WWP3_SEARCH_STATE'))
    //
    // if (storedState) {
    //   this.setState(storedState.state, () => {
    //     if (storedState.state.showMap) {
    //       this.initMap(this.state.shownResults)
    //     }
    //   })
    //   return
    // }

    const dataSrc = find('.js-wwp3-search-data')[0]
    const data = JSON.parse(dataSrc.value)
    const showMap = data.showMap === 1

    this.setState({
      cols: data.cols,
      branches: data.branches,
      types: data.types,
      showMap: showMap,
    }, this.hashChange)
  }

  hashChange() {

    const hash       = window.location.hash.length ? decodeURIComponent( window.location.hash.substr( 1 ) ) : '',
          hashParams = hash.split( '&' );
      let parameters = {};

    hashParams.map( e => {

      e = e.split( '=' );

      if ( e.length ) {

        parameters[ e[ 0 ] ] = e.length > 1 ? e[ 1 ] : '';

      }

    } );

    parameters.get = ( e ) => {

      return ( ( e in parameters ) ? parameters[ e ] : '' );

    };

    const term     = parameters.get( 'q' ),
          location = parameters.get( 'location' ),
          types    = parameters.get( 'types' ).split( ',' );
    let   newState = {};

    newState.term = term;
    newState.location = location;
    newState.types = $.extend( true, [], this.state.types );

    newState.types.map( e => {

      e.active = types.indexOf( e.type ) !== -1;

    } );

    if ( ! types.length ) {

      newState.types[ 0 ].active = true;

    }

    newState.activeTypes = newState.types.filter( o => o.active && o.type !== 'all' );

    if ( term || location ) {

      newState.canSearch = true;

      this.setState( newState, this.search );

    } else {

      this.setState( newState );

    }

  }

  initMap(data) {
    this.mapEl = find('.wwp3-search__map')[0]
    this.mapEl.style.display = 'block'
    this.map = new Map()
    this.map.createMap(this.mapEl, {disableDefaultUI: false}, data)
  }

  search() {
    if (!this.state.canSearch) return

    this.setState({ searching: true })

    this.xhr && this.xhr.abort()

    this.xhr = $.ajax({
      data: {
        action: 'wwp3_search',
        ajaxcall: true,
        term: this.state.term,
        filter: JSON.stringify(this.getSearchOptions()),
      },
      success: e => {
        const shownResults = this.applyFilter(e.result, this.state.activeTypes)

        const typeCount = {}
        e.result.map(res => {
          if (typeCount[res.type]) {
            typeCount[res.type] += 1
          } else {
            typeCount[res.type] = 1
          }
        })

        const types = this.state.types.map(t => {
          const count =
            t.type === 'all' ? e.result.length : typeCount[t.type] || null // display checks against null not undefined
          return { ...t, count } // update count value
        })

        this.setState(
          {
            results: e.result,
            shownResults,
            total: shownResults.length,
            searching: false,
            types,
          },
          () => {
            // this.saveSearchResult(this.state)

            if (!this.state.showMap) return

            if (!this.map) {
              // initialize map only of search returned a result
              this.state.total && this.initMap(this.state.shownResults)
            } else {
              this.map.updateMap(this.map.getMap(), this.state.shownResults)
              this.mapEl.style.display = this.state.total ? 'block' : 'none'
            }
          }
        )
        this.xhr = null
      },
      type: 'post',
      url: window.wwp3['ajaxurl'],
    })
  }

  getSearchOptions() {
    const params = {
      limit: 10000,
    }

    if (this.state.activeTypes.length > 0) {
      params.types = this.state.activeTypes
    }

    if (this.state.activeBranches.length > 0) {
      params.branches = this.state.activeBranches
    }

    if (this.state.location) {
      params.location = this.state.location
    }

    return params
  }

  handleInputChange(evt, type) {
    this.setState(
      {
        [type]: evt.target.value,
      },
      () => {
        if (this.state.term === '' && this.state.location === '') {
          this.setState({
            canSearch: false,
          })
        }
        if (
          (this.state.term !== '' || this.state.location !== '') &&
          !this.state.canSearch
        ) {
          this.setState({
            canSearch: true,
          })
        }
      }
    )
  }

  applyFilter(results, activeTypes) {
    return results.filter(r => {
      if (activeTypes.length === 0) return r

      let found = false

      activeTypes.map(at => {
        if (at.type === r.type) {
          found = true
        }
      })

      return found
    })
  }

  onUpdateTypes(activeTypes) {
    const shownResults = this.applyFilter(this.state.results, activeTypes)

    this.setState(
      {
        activeTypes,
        shownResults,
        total: shownResults.length,
      },
      () => {
        this.map &&
          this.state.showMap &&
          this.map.updateMap(this.map.getMap(), this.state.shownResults)
      }
    )
  }

  onUpdateBranches(branches) {
    this.setState({
      branches,
    })
  }

  hideMap() {
    if (!this.mapEl) {
      this.mapEl = find('.wwp3-search__map')[0]
    }
    this.mapEl.style.display = 'none'
  }

  // saveSearchResult(state) {
  //   sessionStorage.setItem(
  //     'WWP3_SEARCH_STATE',
  //     JSON.stringify({
  //       state,
  //       timestamp: new Date().getTime(),
  //     })
  //   )
  // }

  onSubmit(evt) {
    evt.preventDefault()
    // this.search()

    let types = [], hash = '';

    this.state.activeTypes.map( (e) => { types.push( e.type ); } );

    if ( this.state.term ) {

      hash = 'q=' + this.state.term;

    }

    if ( this.state.location ) {

      hash += ( hash ? '&' : '' ) + 'location=' + this.state.location;

    }

    if ( types.length ) {

      hash += ( hash ? '&' : '' ) + 'types=' + types.join( ',' );

    }

    window.location.hash = ( hash ? ( '#' + hash ) : '' );

  }

  render() {
    let buttonClasses = 'wwp3-button'
    if (!this.state.canSearch) {
      buttonClasses += ' wwp3-button--disabled'
    }

    return (
      <div
        className={`wwp3-search ${
          this.state.searching ? 'wwp3-is-searching' : ''
        }`}
      >
        <form className="wwp3-search-box" onSubmit={evt => this.onSubmit(evt)}>
          <div className="wwp3-search-inputs">
            <div className="wwp3-search-input-box">
              <SearchIcon />
              <input
                className={`wwp3-search__input wwp3-input search`}
                type="text"
                value={this.state.term}
                onChange={evt => this.handleInputChange(evt, 'term')}
                placeholder={__('textKeywords')}
              />
            </div>

            <div className="wwp3-search-input-box">
              <LocationIcon />
              <input
                className={`wwp3-search__input wwp3-input search`}
                type="text"
                value={this.state.location}
                onChange={evt => this.handleInputChange(evt, 'location')}
                placeholder={__('textLocation')}
              />
            </div>

            {/* <div className="wwp3-search-input-box"> */}
            {/*   <FilterIcon /> */}
            {/* </div> */}
          </div>

          <div className="wwp3-search-input-box wwp3-search-input-box--button">
            <button className={buttonClasses} type="submit">
              <span className={this.state.searching ? 'wwp3-hidden' : ''}>
                {__('textSearch')}
              </span>
              {this.state.searching && (
                <div className="wwp3-loader-box">
                  <div className="wwp3-loader">Loading...</div>
                </div>
              )}
            </button>
          </div>
        </form>

        <TypeFilter
          options={this.state.types}
          onUpdate={t => this.onUpdateTypes(t)}
        />
        {/* <BranchFilter */}
        {/*   options={[{ term_id: -1, name: 'Alle' }, ...this.state.branches]} */}
        {/*   onUpdate={b => this.onUpdateBranches(b)} */}
        {/* /> */}
        <div className="wwp3-search__results">
          {/*{this.state.total !== null && (*/}
          {/*  <span className="wwp3-search__found">{`${this.state.total} ${__(*/}
          {/*    'textEntriesFound'*/}
          {/*  )}`}</span>*/}
          {/*)}*/}
          <div className="wwp3-search__map" />
          <ul className="wwp3-sponsors">
            {this.state.shownResults.map(r => {
              return (
                <SearchResult key={r.id} result={r} col={this.state.cols} />
              )
            })}
          </ul>
          {this.state.total === 0 && <div className="wwp3-search__no-results">{__('textNoSearchResults')}</div>}
        </div>
      </div>
    )
  }
}

export default Search



// WEBPACK FOOTER //
// src/assets/js/front-end/apps/search/components/Search.js